<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/satisfaction-email">满意度邮件</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">{{$route.meta.title}}</template>
      <el-table :data="table"
                stripe
                highlight-current-row
                :show-header="false"
                class="margin b15"
                style="width: 100%">
        <el-table-column width="150">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
             <div v-if="scope.row.key === 'mail_content'">
               <div v-html="scope.row.value"></div>
                </div>
            <div v-else-if="scope.row.key === 'status' || scope.row.key === 'type' ">
                  <span v-for="item in options[scope.row.key]"
                        v-if="scope.row.value === item.value">{{item.label}}</span>
                </div>
            <div v-else>{{scope.row.value}}</div>

          </template>

        </el-table-column>
      </el-table>
      <router-link to="/satisfaction-email">
        <el-button type="primary">返回</el-button>
      </router-link>
    </layout-panel>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  data () {
    return {
      table: [
        {
          key: 'name',
          label: '名称:',
          value: '',
        },
        {
          key: 'type',
          label: '类型:',
          value: '',
        },
        {
          key: 'status',
          label: '状态:',
          value: 0,
        },
        {
          key: 'mail_title',
          label: '邮件标题:',
          value: '',
        },
        {
          key: 'mail_content',
          label: '邮件正文:',
          value: '',
        },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.satisfactionEmail.options,
    }),
  },
  created () {
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    setDetailData (id) {
      request.page('getSatisfactionEmailDetail', {id}).then(({data}) => {
        this.table.forEach(obj => {
          if (data[obj.key]) {
            obj.value = data[obj.key]
          }
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/satisfaction-email/pages/SatisfactionEmailDetail.vue